// extracted by mini-css-extract-plugin
export default {"root":"ManualDialog_root__wlU3L"};